import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cnnew/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cnnew/node_modules/react-bootstrap/esm/Container.js");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/src/components/SectionHeading/SectionHeading.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CollectionsList"] */ "/var/www/cnnew/src/views/CollectionsView/CollectionsList.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/cnnew/src/views/CollectionsView/CollectionsView.module.scss");
